var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Safety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 10.34s-23.46 9.83-23.62 9.83v6.66c0 26.75 21 35.42 23.62 37.17 0 0 23.66-10.42 23.66-37.17l.09-6.66c-.12 0-23.75-9.83-23.75-9.83zm19.56 16.42c0 19.8-14.37 29.75-19.48 32.67-5.61-3.12-19.6-11.68-19.6-32.6V23.1L38 14.64 57.59 23l-.03 3.76zM34 41.77l16-16.12 2.83 2.83L34 47.4l-9.48-9.28 2.8-2.86L34 41.77z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Safety.5fd39abb.svg";
export { SvgK1Safety as ReactComponent };